import { useTranslation } from "react-i18next";
import { generateTitle } from "../../container/AnalyticsDashboardView/Formatters";
import AnalyticsDashboardLayout from "../../yoello-lib/modules/components/Analytics/AnalyticsDashboardLayout/AnalyticsDashboardLayout";


const startDate = new Date().setHours(0, 0, 0, 0);
const endDate = new Date().setHours(23, 59, 59, 59);

export function SuperuserOverview() {
    const { t } = useTranslation();
    return <AnalyticsDashboardLayout
        hasPermission={false} allVenues={true}
        onDateChange={function (startDate: number | Date, endDate: number | Date): void {
            throw new Error("Function not implemented.");
        }}
        categorySummary={{ title: generateTitle(t, t('analytics.categories.title'), startDate, endDate) } as any}
        lineChart={{ title: generateTitle(t, t('analytics.columnChart.title'), startDate, endDate), data: [] } as any}
        totalsList={{ title: generateTitle(t, t('analytics.totals.title'), startDate, endDate) } as any} />
}